import { GatewayLogType } from '../../utils/types';

// Filter functions

// Filter used to allow all logs to pass through before any other filters are applied.
const defaultTrueFilter = (entry: GatewayLogType, args: {}) => true;

// Filter to hide or show site-only logs.
const siteOnlyFilter = (entry: GatewayLogType, args: { apply: boolean }) => {
  if (
    [undefined, null, false].includes(entry.metadata.site_only) ||
    args.apply === true
  ) {
    return true;
  } else {
    return false;
  }
};

// Filter to hide or show user logs (i.e. not site-only).
const userFilter = (entry: GatewayLogType, args: { apply: boolean }) => {
  if (entry.metadata.site_only === true || args.apply === true) {
    return true;
  } else {
    return false;
  }
};

// Filter to show logs for specific site.
const siteUuidFilter = (entry: GatewayLogType, args: { uuid: string }) => {
  if ([undefined, null, ''].includes(entry.metadata.site_uuid)) return true;
  return entry.metadata.site_uuid === args.uuid;
};

// Index mapping filter name to function.
export const logFilterIndex = new Map<string, CallableFunction>([
  ['defaultTrue', defaultTrueFilter],
  ['user', userFilter],
  ['siteOnly', siteOnlyFilter],
  ['siteUuid', siteUuidFilter],
]);
